module.exports = __webpack_public_path__ + "static/media/ic_nocomunication.15d7e812.svg";